<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Detect Datail</strong>
            <small v-if="!add && model.detected_at">StartTime : ({{model.detected_at | datetime}})</small>
          </div>
          <b-row>
            <!-- <b-col md="4">
              <b-form-group>
                <label for="ph_version" v-b-tooltip.hover>Version</label><br>
                <label for="ph_version">{{model.ver}}</label>
              </b-form-group>
            </b-col> -->
            <b-col md="8">
              <b-form-group>
                <label for="ph_task_key" v-b-tooltip.hover>task_key</label><br>
                <label for="ph_task_key">{{model.task_key}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_username" v-b-tooltip.hover>Name</label><br>
                <label for="ph_domain">{{model.name || 'None'}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_domain" v-b-tooltip.hover>Domain</label><br>
                <label for="ph_domain">{{model.domain}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Level</label><br>
                <label for="ph_page" v-if="model && model.level">{{codes.WMDS_TYPE[model.level]}} Level</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Type</label><br>
                <label for="ph_ext" v-if="model && model.type">{{codes.WMDS_TYPE[model.type]}} Type</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Detect DEPTH</label><br>
                <label for="ph_detect" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).depth}} Depth</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>HASH</label><br>
                <label for="ph_ext" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).url_hash}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>MD5</label><br>
                <label for="ph_ext" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).md5}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Check Code</label><br>
                <label for="ph_detect" v-if="model.detail_data && (JSON.parse(model.detail_data).f1code || JSON.parse(model.detail_data).ucode)">{{JSON.parse(model.detail_data).f1code || JSON.parse(model.detail_data).ucode}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="image">
            <b-col md="12">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Screenshot</label><br>
                <a @click="toggle_thumbnail" ><img :src="image" :style="{ width: thumbnail_size }"></a>
              </b-form-group>
            </b-col>
          </b-row>
          <template>
              <b-button size="sm" variant="danger" @click="confirm = true"> Remove </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Detect Path</strong>
          </div>
          <b-row>
            <b-col md="12">
              <pre slot="body" style="max-width: 100%; max-height: 500px; overflow:auto;">
                <!-- <div v-for="(item, index) in page_list" :key="index" :style="{ 'padding-left' : index * 10 + 'px'}">{{item}} -->
                <div v-for="(item, index) in url_tree" :key="index">{{item}}
                </div>
              </pre>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>HTML Data</strong>
          </div>
          <b-row>
            <b-col md="12">
              <!-- <pre style="max-height: 500px; max-width: 100%; overflow:auto;">{{model}}</pre> -->
              <!-- <pre style="max-height: 500px; max-width: 100%; overflow:auto;">{{model.detail_data}}</pre> -->
              <div style="max-height: 500px; overflow: auto;">
                <pre slot="body" style="width: 3000px; overflow: visible;" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Would You Like to Remove?
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';

export default {
  data : () => {
    return {
      codes,
      thumbnail_size: '25%',
      confirm: false,
      add: false,
      model : {},
      url_tree : {},
      thumbnail : ''
    }
  },
  computed: {
    image() { return this.thumbnail && 'data:image/png;base64,' + this.thumbnail || ''; }
  },
  methods: {
    toggle_thumbnail() { this.thumbnail_size = this.thumbnail_size == '25%' ? '100%' : '25%'; },
    list() { this.$router.push({ name: 'wmds_detect'}); },
    async remove() {
      try {
        let rs = await Api.Manager_Call('wmds.detect', 'delete', { id : this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list(); this.$emit("refresh")
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }
      try{
        let rs = await Api.Manager_Call('wmds.detect', 'detail', { id : id })
        this.url_tree = (JSON.parse(rs.body.detail_data).url_tree).reverse()
        this.thumbnail = (JSON.parse(rs.body.detail_data).thumbnail)
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
